module.exports = __webpack_public_path__ + "static/home-slider3-28b238ee66cb960f8f6e9b63390e5fbc.jpeg";